import styled from 'styled-components/macro';
import { ExpandControlChevron } from '../../../shared/ExpandControlChevron';
import { spacing03 } from '../../../styling/spacing';

export const QuoteOrDesignFormExpandControlChevron = styled(ExpandControlChevron)`
  margin-left: ${spacing03};
  margin-top: 3px;
`;
